import { useCallback } from 'react'

const useOpenNewWindow = (href: string) => useCallback(() => window.open(href), [href])

export { useOpenNewWindow }
